import * as React from 'react';
import { Link } from 'react-router-dom';
import { cn, getText, superScriptSanitizer } from '../../helpers';
import { ReactComponent as HomeIcon } from '../../assets/svg/icons/home.svg';

function isLast(current: number, total: number): boolean {
    return current === total - 1;
}

const homeText = getText('generic.home');
const langCode = getText('langCode');

const BreadCrumb = function PureComponent(props: BreadcrumbItemArray) {
    const { pathData, noMargin, sanitizeSuperScript, showTruncated } = props;

    const onHomeBtnClick = () => {
        const event = new Event('HomeButtonClick');
        document.dispatchEvent(event);
    };

    const getUpdatedPath = (value: string) => {
        if (value.length > 75 && showTruncated) {
            const truncatedValue = value.substring(0, 75);
            const lastSpaceIndex = truncatedValue.lastIndexOf(' ');
            return `${truncatedValue.substring(0, lastSpaceIndex)}...`;
        }
        return value;
    };

    return (
        <nav aria-label="Breadcrumb" className={cn('breadcrumb', 'page-section', { 'breadcrumb--no-margin': noMargin })} data-testid="breadcrumb">
            <div className="page-section__inner">
                <ol
                    className="breadcrumb__list"
                    itemScope
                    itemType="https://schema.org/BreadcrumbList"
                >
                    <li className="breadcrumb__item breadcrumb__item--home" data-testid="breadcrumb-item">
                        <Link to={`/${langCode}`} className="breadcrumb__link" itemProp="url" title={homeText} onClick={onHomeBtnClick}>
                            <HomeIcon aria-label={homeText} />
                        </Link>
                    </li>
                    {pathData &&
                        pathData.map((pathItem: BreadcrumbItem, index: number) => (
                            <li
                                key={pathItem.text}
                                className="breadcrumb__item"
                                data-testid="breadcrumb-item"
                                itemProp="itemListElement"
                                itemScope
                                itemType="https://schema.org/ListItem"
                            >
                                <Link
                                    to={`/${langCode}${pathItem.url}`}
                                    className="breadcrumb__link"
                                    itemProp="item"
                                    aria-current={isLast(index, pathData.length) ? 'page' : undefined}
                                    title=""
                                >
                                    <span itemProp="name">{sanitizeSuperScript ? superScriptSanitizer(getUpdatedPath(pathItem.text)) : pathItem.text}</span>
                                    <meta content={index.toString()} itemProp="position" />
                                </Link>
                            </li>
                        ))}
                </ol>
            </div>
        </nav>
    );
};

export default React.memo(BreadCrumb);
